import copilotSettingsStore from 'owa-copilot-settings-store/lib/store/store';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Returns true when the user has at least one effective Copilot license of any
 * `LicenseType` (M365Copilot, TeamsCopilot, BizChat, SalesCopilot,
 * M365ConsumerCredits). Use this when the caller only needs to know whether
 * *any* Copilot experience is licensed, and does not need to distinguish
 * between specific SKUs.
 */
export const hasAnyCopilotLicense = (mailboxInfo: MailboxInfo): boolean => {
    const store = copilotSettingsStore(mailboxInfo);
    if (store.isEnabled) {
        return store.licenses.length > 0;
    }

    return false;
};

export default hasAnyCopilotLicense;
